import React from "react";

/**
 * Screen-space rulers rendered on top of the ZoneEditor canvas. The
 * tick spacing auto-adjusts based on the current zoom so ticks stay
 * roughly ~60 px apart regardless of scale. Extracted from the main
 * ZoneEditor during the iter-38 refactor — this is a pure component
 * that only reads its props.
 */
export default function Rulers({ containerSize, mediaSize, totalScale, pan }) {
  if (!mediaSize.w || !mediaSize.h) return null;
  // Centered media wrapper math — mirror of `wrapperStyle` in the editor.
  const offX = (containerSize.w - mediaSize.w * totalScale) / 2 + pan.x;
  const offY = (containerSize.h - mediaSize.h * totalScale) / 2 + pan.y;
  const targetTickPx = 60;
  const rawStep = targetTickPx / totalScale;
  const niceSteps = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000];
  const step = niceSteps.find((s) => s >= rawStep) ?? niceSteps[niceSteps.length - 1];
  const RULER_PX = 18;

  const topTicks = [];
  for (let x = 0; x <= mediaSize.w; x += step) {
    const sx = offX + x * totalScale;
    if (sx < 0 || sx > containerSize.w) continue;
    topTicks.push({ x: sx, label: x });
  }
  const leftTicks = [];
  for (let y = 0; y <= mediaSize.h; y += step) {
    const sy = offY + y * totalScale;
    if (sy < 0 || sy > containerSize.h) continue;
    leftTicks.push({ y: sy, label: y });
  }

  return (
    <div className="absolute inset-0 pointer-events-none" data-testid="zone-rulers">
      {/* Top ruler */}
      <div className="absolute left-0 top-0 right-0 bg-zinc-900/65 text-white text-[9px] font-mono"
        style={{ height: RULER_PX, paddingLeft: RULER_PX }}>
        {topTicks.map(({ x, label }) => (
          <span key={label} className="absolute top-0 bottom-0 border-l border-white/40 px-0.5"
            style={{ left: x - 1, lineHeight: `${RULER_PX}px` }}>
            {label}
          </span>
        ))}
      </div>
      {/* Left ruler */}
      <div className="absolute left-0 top-0 bottom-0 bg-zinc-900/65 text-white text-[9px] font-mono"
        style={{ width: RULER_PX, paddingTop: RULER_PX }}>
        {leftTicks.map(({ y, label }) => (
          <span key={label} className="absolute left-0 right-0 border-t border-white/40 px-0.5"
            style={{ top: y - 0.5, lineHeight: "10px" }}>
            {label}
          </span>
        ))}
      </div>
      {/* Corner cap */}
      <div className="absolute left-0 top-0 bg-zinc-900/80" style={{ width: RULER_PX, height: RULER_PX }} />
    </div>
  );
}
